import { Navigate, useLocation } from "react-router-dom";
import { resolveRedirect } from "@/utils/redirectMap";

const isAbsoluteHttpUrl = (value: string) => /^https?:\/\//i.test(value);

const appendCurrentLocationSuffix = (
  target: string,
  location: ReturnType<typeof useLocation>,
) => {
  // A target such as /resurser/utvecklare#mcp keeps its own fragment unless
  // the visitor asked for a more specific one.
  const [path, fragment = ""] = target.split("#");
  const hash = location.hash || (fragment ? `#${fragment}` : "");
  return `${path}${location.search}${hash}`;
};

/**
 * Client-side redirect handler for legacy URLs during in-app SPA navigation.
 *
 * The mapping lives in @/utils/redirectMap so the SSR server can emit real HTTP
 * 301s for the same paths (what search engines honour). This component only
 * keeps client-side navigation consistent; it is not what Google sees.
 */
export const Redirects = () => {
  const location = useLocation();
  const newPath = resolveRedirect(location.pathname);

  if (newPath) {
    const target = appendCurrentLocationSuffix(newPath, location);
    if (isAbsoluteHttpUrl(newPath)) {
      if (typeof window !== "undefined") {
        window.location.replace(target);
      }
      return null;
    }

    return <Navigate to={target} replace />;
  }

  return null;
};
